import { PROJECT_PERMISSIONS } from './projects/project.permissions';
export const PERMISSIONS = {
    InstanceAdmin: 'platform:instance:manage',
    WorkspaceAdmin: 'platform:manage-workspaces',
    OrganizationAdmin: 'platform:modify-all',
    KnowledgeHubViewFoundationalKnowledgeBases: 'knowledge-hub:view-foundational-knowledge-bases',
    KnowledgeHubManageFoundationalKnowledgeBases: 'knowledge-hub:manage-foundational-knowledge-bases',
    KnowledgeHubViewOrganizationKnowledgeBases: 'knowledge-hub:view-organization-knowledge-bases',
    KnowledgeHubManageOrganizationKnowledgeBases: 'knowledge-hub:manage-organization-knowledge-bases',
    KnowledgeHubViewWorkspaceKnowledgeBases: 'knowledge-hub:view-workspace-knowledge-bases',
    KnowledgeHubManageWorkspaceKnowledgeBases: 'knowledge-hub:manage-workspace-knowledge-bases',
    KnowledgeHubViewBrandVisualGuidelines: 'knowledge-hub:view-brand-visual-guidelines',
    KnowledgeHubManageBrandVisualGuidelines: 'knowledge-hub:manage-brand-visual-guidelines',
    KnowledgeHubViewBrandAssets: 'knowledge-hub:view-brand-assets',
    KnowledgeHubUploadBrandAssets: 'knowledge-hub:upload-brand-assets',
    KnowledgeHubManageBrandAssets: 'knowledge-hub:manage-brand-assets',
    ContentStudioView: 'content-studio:view',
    ContentStudioCreateAdsets: 'content-studio:create-adsets',
    ContentStudioEditAdsets: 'content-studio:edit-adsets',
    ContentStudioDeleteAdsets: 'content-studio:delete-adsets',
    ContentStudioCreateRuns: 'content-studio:create-runs',
    ContentStudioExportRuns: 'content-studio:export-runs',
    ContentStudioManageAdFormats: 'content-studio:manage-ad-formats',
    KnowledgeHubViewBriefTemplates: 'knowledge-hub:view-brief-templates',
    KnowledgeHubManageBriefTemplates: 'knowledge-hub:manage-brief-templates',
    KnowledgeHubViewWorkspaceBriefTemplates: 'knowledge-hub:view-workspace-brief-templates',
    KnowledgeHubManageWorkspaceBriefTemplates: 'knowledge-hub:manage-workspace-brief-templates',
    KnowledgeHubViewOrganizationBriefTemplates: 'knowledge-hub:view-organization-brief-templates',
    KnowledgeHubManageOrganizationBriefTemplates: 'knowledge-hub:manage-organization-brief-templates',
    KnowledgeHubManageSystemBriefTemplates: 'knowledge-hub:manage-system-brief-templates',
    KnowledgeHubViewAudiences: 'knowledge-hub:view-audiences',
    KnowledgeHubManageAudiences: 'knowledge-hub:manage-audiences',
    KnowledgeHubManageEmailTemplates: 'knowledge-hub:manage-email-templates',
    KnowledgeHubViewTaxonomy: 'knowledge-hub:view-taxonomy',
    KnowledgeHubManageTaxonomy: 'knowledge-hub:manage-taxonomy',
    // Platform permissions
    PlatformManageTools: 'platform:manage-tools',
    PlatformViewCostDashboard: 'platform:view-cost-dashboard',
    PlatformManageCredentials: 'platform:manage-credentials',
    PlatformManageModelsWhitelisting: 'platform:manage-models-whitelisting',
    PlatformManageUserAgents: 'platform:manage-user-agents',
    PlatformViewUserAgents: 'platform:view-user-agents',
    PlatformAccessSupport: 'platform:access-support',
    // Tool open permissions
    ToolAudienceFlowAgentOpen: 'tool:audience-flow-agent:open',
    ToolCopyGenerationOpen: 'tool:copy-generation:open',
    ToolVideoGenerationOpen: 'tool:video-generation:open',
    ToolSentinelBuddyAgentOpen: 'tool:sentinel-buddy-agent:open',
    ToolImageGenerationOpen: 'tool:image-generation:open',
    ToolStrategyAgentV3Open: 'tool:strategy-agent-v3:open',
    ToolTranslationAgentOpen: 'tool:translation-agent:open',
    ToolIdeationOpen: 'tool:ideation:open',
    ToolResourcesOpen: 'tool:resources:open',
    ToolFlowDigestAgentOpen: 'tool:flow-digest-agent:open',
    ToolNacbIntakeOpen: 'tool:nacb-intake:open',
    ToolFocusGroupsOpen: 'tool:focus-groups:open',
    ToolTestContentOpen: 'tool:test-content:open',
    ToolTemplatesOpen: 'tool:templates:open',
    ToolIqOpen: 'tool:iq:open',
    ToolFabricOpen: 'tool:fabric:open',
    ToolCreativeIntelligenceOpen: 'tool:creative-intelligence:open',
    // Not "tool:": platform-api bundles every tool:* key into an OAuth scope that
    // only promises to use tools, so an admin key there would widen consented tokens.
    CreativeIntelligenceManage: 'creative-intelligence:manage',
    // Integration permissions
    IntegrationGwiAccess: 'integration:gwi:access',
    IntegrationYougovAccess: 'integration:yougov:access',
    IntegrationPathmaticsAccess: 'integration:pathmatics:access',
    IntegrationStatistaAccess: 'integration:statista:access',
    // Project permissions
    ...PROJECT_PERMISSIONS,
    // Resolved at workspace scope, so not one of the PROJECT_PERMISSIONS: those are
    // checked against a single project's permission list, which this key never
    // appears in.
    ProjectCreate: 'project:create',
};
/**
 * Permission rules for each knowledge hub resource.
 * `view` lists permissions that grant read access (manage implies view).
 * `manage` lists permissions that grant write access.
 * Both FE and BE should reference these rules to stay aligned.
 */
/**
 * Brief templates live at three levels. The legacy pair predates the split and is still all
 * that tokens issued before it carry, so it keeps opening workspace templates and reading
 * organization ones. Writing an organization template or a system default needs the new key
 * outright: the legacy manage key was handed to every workspace editor, and reading it as
 * organization-wide would widen every one of them.
 */
const WORKSPACE_BRIEF_TEMPLATE_RULES = {
    view: [
        PERMISSIONS.KnowledgeHubViewWorkspaceBriefTemplates,
        PERMISSIONS.KnowledgeHubManageWorkspaceBriefTemplates,
        PERMISSIONS.KnowledgeHubViewBriefTemplates,
        PERMISSIONS.KnowledgeHubManageBriefTemplates,
    ],
    manage: [
        PERMISSIONS.KnowledgeHubManageWorkspaceBriefTemplates,
        PERMISSIONS.KnowledgeHubManageBriefTemplates,
    ],
};
const ORGANIZATION_BRIEF_TEMPLATE_RULES = {
    view: [
        PERMISSIONS.KnowledgeHubViewOrganizationBriefTemplates,
        PERMISSIONS.KnowledgeHubManageOrganizationBriefTemplates,
        PERMISSIONS.KnowledgeHubViewBriefTemplates,
        PERMISSIONS.KnowledgeHubManageBriefTemplates,
    ],
    manage: [PERMISSIONS.KnowledgeHubManageOrganizationBriefTemplates],
};
/** System defaults are readable by anyone who can read templates at any level. */
const SYSTEM_BRIEF_TEMPLATE_RULES = {
    view: [
        ...new Set([
            ...WORKSPACE_BRIEF_TEMPLATE_RULES.view,
            ...ORGANIZATION_BRIEF_TEMPLATE_RULES.view,
            PERMISSIONS.KnowledgeHubManageSystemBriefTemplates,
        ]),
    ],
    manage: [PERMISSIONS.KnowledgeHubManageSystemBriefTemplates],
};
export const KNOWLEDGE_HUB_PERMISSION_RULES = {
    foundationalKnowledgeBases: {
        view: [
            PERMISSIONS.KnowledgeHubViewFoundationalKnowledgeBases,
            PERMISSIONS.KnowledgeHubManageFoundationalKnowledgeBases,
        ],
        manage: [PERMISSIONS.KnowledgeHubManageFoundationalKnowledgeBases],
    },
    organizationKnowledgeBases: {
        view: [
            PERMISSIONS.KnowledgeHubViewOrganizationKnowledgeBases,
            PERMISSIONS.KnowledgeHubManageOrganizationKnowledgeBases,
        ],
        manage: [PERMISSIONS.KnowledgeHubManageOrganizationKnowledgeBases],
    },
    workspaceKnowledgeBases: {
        view: [
            PERMISSIONS.KnowledgeHubViewWorkspaceKnowledgeBases,
            PERMISSIONS.KnowledgeHubManageWorkspaceKnowledgeBases,
        ],
        manage: [PERMISSIONS.KnowledgeHubManageWorkspaceKnowledgeBases],
    },
    brandVisualGuidelines: {
        view: [
            PERMISSIONS.KnowledgeHubViewBrandVisualGuidelines,
            PERMISSIONS.KnowledgeHubManageBrandVisualGuidelines,
        ],
        manage: [PERMISSIONS.KnowledgeHubManageBrandVisualGuidelines],
    },
    brandAssets: {
        open: [
            PERMISSIONS.KnowledgeHubViewBrandAssets,
            PERMISSIONS.KnowledgeHubUploadBrandAssets,
            PERMISSIONS.KnowledgeHubManageBrandAssets,
        ],
        read: [
            PERMISSIONS.KnowledgeHubViewBrandAssets,
            PERMISSIONS.KnowledgeHubUploadBrandAssets,
            PERMISSIONS.KnowledgeHubManageBrandAssets,
            PERMISSIONS.ContentStudioView,
            PERMISSIONS.ContentStudioCreateAdsets,
            PERMISSIONS.ContentStudioEditAdsets,
            PERMISSIONS.ContentStudioDeleteAdsets,
            PERMISSIONS.ContentStudioCreateRuns,
            PERMISSIONS.ContentStudioExportRuns,
        ],
        upload: [PERMISSIONS.KnowledgeHubUploadBrandAssets],
        manage: [PERMISSIONS.KnowledgeHubManageBrandAssets],
        boardFolder: [PERMISSIONS.ContentStudioCreateAdsets, PERMISSIONS.ContentStudioEditAdsets],
        createFont: [
            PERMISSIONS.KnowledgeHubUploadBrandAssets,
            PERMISSIONS.ContentStudioCreateAdsets,
            PERMISSIONS.ContentStudioEditAdsets,
        ],
    },
    audiences: {
        view: [PERMISSIONS.KnowledgeHubViewAudiences, PERMISSIONS.KnowledgeHubManageAudiences],
        manage: [PERMISSIONS.KnowledgeHubManageAudiences],
    },
    /** Any level: what opens the feature at all. The per-level split is enforced per template. */
    briefTemplates: {
        view: SYSTEM_BRIEF_TEMPLATE_RULES.view,
        manage: [
            ...new Set([
                ...WORKSPACE_BRIEF_TEMPLATE_RULES.manage,
                ...ORGANIZATION_BRIEF_TEMPLATE_RULES.manage,
                ...SYSTEM_BRIEF_TEMPLATE_RULES.manage,
            ]),
        ],
    },
    workspaceBriefTemplates: WORKSPACE_BRIEF_TEMPLATE_RULES,
    organizationBriefTemplates: ORGANIZATION_BRIEF_TEMPLATE_RULES,
    systemBriefTemplates: SYSTEM_BRIEF_TEMPLATE_RULES,
    taxonomy: {
        view: [PERMISSIONS.KnowledgeHubViewTaxonomy, PERMISSIONS.KnowledgeHubManageTaxonomy],
        manage: [PERMISSIONS.KnowledgeHubManageTaxonomy],
    },
    emailTemplates: {
        // `view` covers *using* the templates agent (read template definitions): both the
        // templates-agent open permission and the manage permission grant it.
        view: [PERMISSIONS.KnowledgeHubManageEmailTemplates, PERMISSIONS.ToolTemplatesOpen],
        // `manage` covers configuring templates (the config screen + write): manage only.
        manage: [PERMISSIONS.KnowledgeHubManageEmailTemplates],
    },
};
export const CONTENT_STUDIO_PERMISSION_RULES = {
    view: [
        PERMISSIONS.ContentStudioView,
        PERMISSIONS.ContentStudioCreateAdsets,
        PERMISSIONS.ContentStudioEditAdsets,
        PERMISSIONS.ContentStudioDeleteAdsets,
        PERMISSIONS.ContentStudioCreateRuns,
        PERMISSIONS.ContentStudioExportRuns,
    ],
    createAdsets: [PERMISSIONS.ContentStudioCreateAdsets],
    editAdsets: [PERMISSIONS.ContentStudioEditAdsets],
    deleteAdsets: [PERMISSIONS.ContentStudioDeleteAdsets],
    createRuns: [PERMISSIONS.ContentStudioCreateRuns],
    exportRuns: [PERMISSIONS.ContentStudioExportRuns],
};
export const USER_AGENTS_PERMISSION_RULES = {
    view: [PERMISSIONS.PlatformViewUserAgents, PERMISSIONS.PlatformManageUserAgents],
    manage: [PERMISSIONS.PlatformManageUserAgents],
};
/**
 * Who may READ / WRITE brief templates at any level: the coarse gate on the API routes. Which
 * level a caller may touch is decided per template by the service.
 *
 * Its own set rather than the whole-hub `ANY_KB_*` lists: Brief Templates used
 * to be reachable by anyone who could see any knowledge base, which made it
 * impossible to grant or revoke on its own.
 */
export const BRIEF_TEMPLATES_VIEW_PERMISSIONS = KNOWLEDGE_HUB_PERMISSION_RULES.briefTemplates.view;
export const BRIEF_TEMPLATES_MANAGE_PERMISSIONS = KNOWLEDGE_HUB_PERMISSION_RULES.briefTemplates.manage;
/** All permissions that grant view access to any knowledge base type */
export const ANY_KB_VIEW_PERMISSIONS = [
    ...KNOWLEDGE_HUB_PERMISSION_RULES.foundationalKnowledgeBases.view,
    ...KNOWLEDGE_HUB_PERMISSION_RULES.organizationKnowledgeBases.view,
    ...KNOWLEDGE_HUB_PERMISSION_RULES.workspaceKnowledgeBases.view,
];
/** All permissions that grant manage access to any knowledge base type */
export const ANY_KB_MANAGE_PERMISSIONS = [
    ...KNOWLEDGE_HUB_PERMISSION_RULES.foundationalKnowledgeBases.manage,
    ...KNOWLEDGE_HUB_PERMISSION_RULES.organizationKnowledgeBases.manage,
    ...KNOWLEDGE_HUB_PERMISSION_RULES.workspaceKnowledgeBases.manage,
];
/**
 * Who may READ knowledge-base listings/files via the API. Superset of
 * `ANY_KB_VIEW_PERMISSIONS`: it additionally lets feature consumers (the
 * templates agent) read KBs to pick campaigns/images — WITHOUT granting them
 * the Knowledge Hub KB-browsing UI, which stays gated by
 * `ANY_KB_VIEW_PERMISSIONS` (via the FE `canViewAnyKnowledgeBase` selector).
 *
 * Needed because the frontend hits these endpoints with the user's raw token;
 * the OIDC token-exchange escalation to KB-view only applies to the agent's
 * server-side calls, not browser calls. Use this on the KB *read* endpoints
 * (list KBs, list files, file content); keep write endpoints on
 * `ANY_KB_MANAGE_PERMISSIONS`.
 */
export const ANY_KB_READ_PERMISSIONS = [
    ...ANY_KB_VIEW_PERMISSIONS,
    PERMISSIONS.KnowledgeHubManageEmailTemplates,
    PERMISSIONS.ToolTemplatesOpen,
];
/**
 * Maps a tool's `toolId` to permission rules for its tool-context-data
 * endpoints. `view` covers read operations (GET); `manage` covers writes
 * (POST/DELETE). Any-of semantics within each list. Tools not in this map
 * fall back to requiring WorkspaceAdmin (see `hasToolContextDataPermission`).
 *
 * Mirrors the shape of `KNOWLEDGE_HUB_PERMISSION_RULES` so adding a future
 * read-only permission (e.g. "use templates agent") is a one-line change to
 * the `view` list — without granting write access.
 */
export const TOOL_CONTEXT_DATA_PERMISSIONS = {
    get_template_v2_tool: {
        // Read (used by chat + config to load template definitions): manage OR the
        // read-only "use templates agent" permission.
        view: [
            PERMISSIONS.WorkspaceAdmin,
            PERMISSIONS.KnowledgeHubManageEmailTemplates,
            PERMISSIONS.ToolTemplatesOpen,
        ],
        // Write (create/edit/delete template definitions): manage only.
        manage: [PERMISSIONS.WorkspaceAdmin, PERMISSIONS.KnowledgeHubManageEmailTemplates],
    },
};
/**
 * Check whether a user can read or write tool-context-data for a given toolId.
 * Tools not listed in `TOOL_CONTEXT_DATA_PERMISSIONS` fall back to requiring
 * `WorkspaceAdmin` — preserving the historical default gate.
 */
export function hasToolContextDataPermission(userPermissions, toolId, action) {
    const allowed = toolId in TOOL_CONTEXT_DATA_PERMISSIONS
        ? TOOL_CONTEXT_DATA_PERMISSIONS[toolId][action]
        : [PERMISSIONS.WorkspaceAdmin];
    return allowed.some((p) => userPermissions.includes(p));
}
/**
 * Maps agent IDs to the permission(s) required to open them.
 * Used by the engine (BE) and the tools list (FE) to gate agent access.
 * A single permission requires exactly that permission; an array is any-of.
 */
export const AGENT_TOOL_OPEN_PERMISSIONS = {
    'audience-flow-agent': PERMISSIONS.ToolAudienceFlowAgentOpen,
    'copy-generation': PERMISSIONS.ToolCopyGenerationOpen,
    'video-generation': PERMISSIONS.ToolVideoGenerationOpen,
    'sentinel-buddy-agent': PERMISSIONS.ToolSentinelBuddyAgentOpen,
    'image-generation': PERMISSIONS.ToolImageGenerationOpen,
    'strategy-agent-v3': PERMISSIONS.ToolStrategyAgentV3Open,
    'translation-agent': PERMISSIONS.ToolTranslationAgentOpen,
    ideation: PERMISSIONS.ToolIdeationOpen,
    'external-tools-agent': PERMISSIONS.ToolResourcesOpen,
    'flow-digest-agent': PERMISSIONS.ToolFlowDigestAgentOpen,
    'nacb-intake': PERMISSIONS.ToolNacbIntakeOpen,
    'focus-groups': PERMISSIONS.ToolFocusGroupsOpen,
    'test-content': PERMISSIONS.ToolTestContentOpen,
    iq: PERMISSIONS.ToolIqOpen,
    fabric: PERMISSIONS.ToolFabricOpen,
    // Managing the feature implies using it.
    'creative-intelligence': [
        PERMISSIONS.ToolCreativeIntelligenceOpen,
        PERMISSIONS.CreativeIntelligenceManage,
    ],
    // Either the templates-agent open permission OR managing email templates lets a user open it.
    templates: [PERMISSIONS.ToolTemplatesOpen, PERMISSIONS.KnowledgeHubManageEmailTemplates],
};
/**
 * Roles that satisfy any scoped gate regardless of granular grants. Lives here
 * so frontend gating and backend enforcement cannot drift: both fold this set
 * into the permissions they require, and adding a role must change both at once.
 */
export const ADMIN_OVERRIDE_PERMISSIONS = [
    PERMISSIONS.OrganizationAdmin,
    PERMISSIONS.WorkspaceAdmin,
];
/**
 * The permission that grants a caller access to one IQ file-upload data source.
 *
 * Vendor-scoped like `integration:gwi:access`, because these are licensed third-party
 * providers a workspace may or may not be entitled to. One key covers everything to do with
 * that provider: activating it in Knowledge, and reading the report sections built from it.
 *
 * Keyed by string rather than by `api`'s `IqDataSource` enum so this library stays free of
 * app types; the enum's values are these keys.
 */
export const IQ_DATA_SOURCE_PERMISSIONS = {
    yougov: PERMISSIONS.IntegrationYougovAccess,
    pathmatics: PERMISSIONS.IntegrationPathmaticsAccess,
};
/** Whether a caller may use one data source, by its `IqDataSource` value. */
export function hasDataSourceAccess(userPermissions, source) {
    const required = IQ_DATA_SOURCE_PERMISSIONS[source];
    return required !== undefined && userPermissions.includes(required);
}
/**
 * Check if a user's permissions include any from a given rule set.
 * Usage: hasAnyPermission(userPermissions, KNOWLEDGE_HUB_PERMISSION_RULES.audiences.view)
 */
export function hasAnyPermission(userPermissions, requiredAny) {
    return requiredAny.some((p) => userPermissions.includes(p));
}
/**
 * Check if a user can open a specific tool/agent.
 * Returns true if the agent has no mapped permission (no gate) or the user has the required permission.
 * Shared between FE and BE so both sides apply the same logic.
 */
export function hasToolOpenPermission(userPermissions, agentId) {
    if (!(agentId in AGENT_TOOL_OPEN_PERMISSIONS)) {
        return true;
    }
    const required = AGENT_TOOL_OPEN_PERMISSIONS[agentId];
    const allowed = Array.isArray(required) ? required : [required];
    return allowed.some((p) => userPermissions.includes(p));
}
